module.exports = __webpack_public_path__ + "static/media/je.ddb5a5ef.svg";